import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AsyncAction } from '../../../core/async-state/models/async-action.model';
import { handleErrors } from '../../../core/async-state/operators/handle-errors';
import { ApiResponse } from '../../../shared/models';
import { GetSubmissionsResponse } from '../../../shared/models/responses/get-submissions-response.modal';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SubmissionApiActions } from '../../users/actions/user-submissions-api.actions';
import { UserSubmissionsApiService } from '../services/user-submissions.services';
import { SubmissionDetails } from 'ngx-esprio-shared';

@Injectable()
export class UserSubmissionEffects {
  public getSubmissions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SubmissionApiActions.getSubmissions),
        switchMap((action) =>
          this.apiService.getSubmissions(action.userId, action.monitoredUserId).pipe(
            handleErrors(() => SubmissionApiActions.getSubmissionsFail()),
            map((res: ApiResponse<GetSubmissionsResponse>) => {
              const submissions = res.data.submissions;

              return SubmissionApiActions.getSubmissionsSuccess({
                payload: { submissions },
              });
            }),
            catchError((errorAction: AsyncAction) => of(errorAction))
          )
        )
      ),
    { dispatch: true }
  );

  public getSubmissionDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SubmissionApiActions.getSubmissionDetails),
        switchMap((action) =>
          this.apiService.getSubmissionDetails(action.userId, action.monitoredUserId, action.submissionId).pipe(
            handleErrors(() => SubmissionApiActions.getSubmissionDetailsFail()),
            map((res: ApiResponse<SubmissionDetails>) =>
              SubmissionApiActions.getSubmissionDetailsSuccess({ payload: res.data })
            ),
            catchError((errorAction: AsyncAction) => of(errorAction))
          )
        )
      ),
    { dispatch: true }
  );

  public loadLatestSubmissionDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SubmissionApiActions.loadLatestSubmissionDetails),
        switchMap((action) =>
          this.apiService.loadLatestSubmissionDetails(action.userId, action.monitoredUserId).pipe(
            handleErrors(() => SubmissionApiActions.loadLatestSubmissionDetailsFail()),
            map((res: ApiResponse<SubmissionDetails>) =>
              SubmissionApiActions.loadLatestSubmissionDetailsSuccess({ payload: res.data })
            ),
            catchError((errorAction: AsyncAction) => of(errorAction))
          )
        )
      ),
    { dispatch: true }
  );

  constructor(private actions$: Actions, private apiService: UserSubmissionsApiService) {}
}
